import { default as PageLayout } from './PageLayout';
import { default as NavigationBottom } from './NavigationBottom';

const EXPORT = { PageLayout, NavigationBottom };

export default EXPORT;
